/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as DynamicLineLayerSpec } from '../../../../layer/preset/line/dynamicLine';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';
import type { Data } from '../../specProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface DynamicLineLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type DynamicLineLayerType = StandardChartLayerSpec &
  DynamicLineLayerSpec &
  DynamicLineLayerTypeWithFields;

// 创建动态折线图数据类型验证器
const validateDynamicLineDataTypes = createDataTypeValidator('dynamicLine', [
  { field: 'x', type: 'date' },
  { field: 'y', type: 'number' },
  { field: 'z', type: 'string', required: false }
]);

// 创建动态折线图编码验证器
const validateDynamicLineEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'z', required: false }
]);

// 额外的检查函数
const additionalDynamicLineChecks = (layer: DynamicLineLayerType, data: Data) => {
  // 检查数据量是否符合要求
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  if (values.length <= 1) {
    utils.logger.warn('warning', `The "${layer.type}" layer requires more than 1 data point`);
    layer.__isEncodingValid = false;
  }
};

// 创建并导出动态折线图处理器
export const dynamicLine = createLayerProcessor<DynamicLineLayerType>(
  'dynamicLine',
  validateDynamicLineEncoding,
  validateDynamicLineDataTypes,
  additionalDynamicLineChecks
);
